import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsFI from './fi.json';
import translationsEN from './en.json';

const resources = {
    fi: {
        translation: {
            ...translationsFI,
        },
    },
    en: {
        translation: {
            ...translationsEN,
        },
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        default: 'fi',
        fallbackLng: localStorage.getItem('locale') || document.documentElement.lang,
        // debug: true,
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        }
    });


export default i18n;



// WEBPACK FOOTER //
// ./resources/assets/js/locales/i18n.js